import { useCallback } from 'react';
import { cn, PopoverInfo, Price } from '@divlab/divanui';
import { IconInfoPopover } from '@divlab/divanui/icons';

import { useRequest } from '@Contexts/Request';
import { useDeps } from '@Contexts/DI';
import useTranslation from '@Queries/useTranslation';
import Link from '@UI/Link';
import styles from './CheaperProduct.module.css';

import type { FC } from 'react';
import type { CheaperProductData } from '@Types/Product';

interface CheaperProductProps {
  className?: string;
  product: CheaperProductData;
}

const CheaperProduct: FC<CheaperProductProps> = (props) => {
  const { product, className, ...restProps } = props;
  const { t } = useTranslation();
  const { country } = useRequest();
  const isUZB = country === 'UZB';
  const { analytics } = useDeps();

  const handleClick = useCallback(() => {
    analytics.dispatchEvent('cheaper.click');
  }, [analytics]);

  return (
    <div {...restProps} className={cn(styles.content, className)}>
      <Link
        to={product.url}
        view={'primary'}
        className={styles.button}
        target='_blank'
        onClick={handleClick}
      >
        <div className={styles.textWrapper}>
          <span className={styles.text}>{t('cheaper')}</span>
          <Price className={styles.price} price={product.price} withoutCurrency={isUZB} />
        </div>
        <div className={styles.arrow}></div>
      </Link>
      <PopoverInfo slotTrigger={<IconInfoPopover />} className={styles.popoverInfo}>
        <div className={styles.popover}>{t('ready-product')}</div>
      </PopoverInfo>
    </div>
  );
};

export default CheaperProduct;
